var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({style:({color: _vm.color, width: _vm.size, height: _vm.size}),attrs:{"src":_vm.src,"alt":"Icon"}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }